module.exports = __webpack_public_path__ + "static/media/lplogo.dfbf93a1.png";